import React from 'react';

function BreadParceiros() {
    return (

        <div id="pageHeader" data-bg-img="assets/img/partner-bread.jpg">
            <div className="container">

                <div className="page-header--title">
                    <h1 className="h1">Nossos Parceiros</h1>
                </div>

                <div className="page-header--breadcrumb">
                    <ul className="breadcrumb">
                        <li><span className="lnr lnr-home"></span></li>
                        <li><a href="../">Início</a></li>
                        <li className="active">Parceiros</li>
                    </ul>
                </div>

            </div>
        </div>

    );
}

export default BreadParceiros;